<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	(editClicked)="openEdit()"
	(deleteClicked)="openDialog()"
	[showEditButton]="canEdit()"
	[showDeleteButton]="canEdit()"
	[disableDeleteButton]="shouldNotBeDeleted()"
	[disableDeleteTranslationKey]="'client.disability.type.details.disabled_delete'"
>
	{{ 'client.disability.type.details.title' | transloco }}
</lvr-heading>

@if (kind(); as kind) {
	<section class="grid" aria-labelledby="client-disability-type">
		<table>
			<tr>
				<th scope="col">{{ 'client.disability.type.edit.status_as_of' | transloco }}:</th>
			</tr>
			<tr>
				<td>{{ isValidDate(kind.statusAsOf) ? (kind.statusAsOf | date: dateDisplayFormat) : '' }}</td>
			</tr>
			<tr>
				<th scope="col">{{ 'base.field.disability_type' | transloco }}:</th>
				<th scope="col" *lvrPermission="readPermissions">{{ 'base.field.differentiation' | transloco }}:</th>
			</tr>
			<tr>
				<td>{{ kind.disabilityType?.remark }}</td>
				<td *lvrPermission="readPermissions">
					{{ kind.categoryDiagnosis?.description }}
				</td>
			</tr>
			<tr>
				<th scope="col">{{ 'client.disability.type.edit.since' | transloco }}:</th>
				<th scope="col">{{ 'client.disability.type.edit.recovered_on' | transloco }}:</th>
			</tr>
			<tr>
				<td>{{ kind.since }}</td>
				<td>{{ isValidDate(kind.recoveredOn) ? (kind.recoveredOn | date: dateDisplayFormat) : '' }}</td>
			</tr>
			<tr *lvrPermission="readPermissions">
				<th scope="col">{{ 'client.disability.type.edit.remark' | transloco }}:</th>
			</tr>
			<tr *lvrPermission="readPermissions">
				<td>{{ kind.remark }}</td>
			</tr>
			<tr *lvrPermission="readPermissions">
				<th scope="colgroup" colspan="2">{{ 'base.field.documents' | transloco }}:</th>
			</tr>
			<tr *lvrPermission="readPermissions">
				<td colspan="2">
					<ul>
						@for (doc of kind.documents; track doc.id) {
							<li>
								<lvr-document-item [document]="buildDocumentEntryFromDisabilityKind(doc)" (open)="onFileClick(doc)">
								</lvr-document-item>
							</li>
						}
					</ul>
				</td>
			</tr>
		</table>
	</section>
}
